import { Blockquote } from "modules/storyblok/components";
import {
  MARK_LINK,
  MARK_STYLED,
  NODE_HEADING,
  NODE_HR,
  NODE_OL,
  NODE_PARAGRAPH,
  NODE_QUOTE,
  NODE_UL,
  render,
} from "storyblok-rich-text-react-renderer";
import { DynamicComponent } from "modules/storyblok/DynamicComponent";
import type { As } from "@chakra-ui/react";
import { ChakraDivider as Divider } from "@airhelp/react-ui-components";
import type { RichtextAdapterProps } from "./RichtextAdapter.d";
import { isEmpty } from "./utils";
import { Link, Heading, Paragraph, UlList, OlList, Styled } from "./RichtextResolvers";
import headingVariants from "../Heading/Heading.config";

const RichtextAdapter = ({ content, customStyles }: RichtextAdapterProps) => {
  if (isEmpty(content)) return null;
  return render(content, {
    nodeResolvers: {
      [NODE_HEADING]: (children, { level }) => (
        <Heading as={`h${level}` as As<any>} variant={headingVariants[level]} styles={customStyles?.heading}>
          {children}
        </Heading>
      ),
      [NODE_PARAGRAPH]: (children) => <Paragraph styles={customStyles?.paragraph}>{children}</Paragraph>,
      [NODE_HR]: () => <Divider sx={customStyles?.horizontalRule} />,
      [NODE_UL]: (children) => <UlList styles={customStyles?.list}>{children}</UlList>,
      [NODE_OL]: (children) => <OlList styles={customStyles?.list}>{children}</OlList>,
      [NODE_QUOTE]: (children) => <Blockquote>{children}</Blockquote>,
    },
    markResolvers: {
      [MARK_LINK]: (children, { href, target, linktype, uuid }) => (
        <Link href={href} target={target} linktype={linktype} styles={customStyles?.link} uuid={uuid}>
          {children}
        </Link>
      ),
      [MARK_STYLED]: (children, { class: className }) => <Styled className={className}>{children}</Styled>,
    },
    defaultBlokResolver: (name, props) => <DynamicComponent blok={{ component: name, ...props } as any} />,
  });
};

export default RichtextAdapter;
